import { useEffect, useState } from "react";

interface UseIsReadyOrTimedOutParams {
    isReady: boolean;
    /** The timeout only counts while this holds, so it can start once the wait can begin. */
    isEnabled: boolean;
    timeoutMs: number;
}

/** True once `isReady` holds or `timeoutMs` has passed since `isEnabled` turned true, so a stalled wait can't block forever. */
export function useIsReadyOrTimedOut({
    isReady,
    isEnabled,
    timeoutMs,
}: UseIsReadyOrTimedOutParams): boolean {
    const [hasTimedOut, setHasTimedOut] = useState(false);

    useEffect(() => {
        if (!isEnabled || isReady) {
            return;
        }
        const timeoutId = setTimeout(() => setHasTimedOut(true), timeoutMs);
        return () => {
            clearTimeout(timeoutId);
            setHasTimedOut(false);
        };
    }, [isEnabled, isReady, timeoutMs]);

    return isReady || hasTimedOut;
}
